import { render, staticRenderFns } from "./AddTools.vue?vue&type=template&id=f0ba7ee8&scoped=true&"
import script from "./AddTools.vue?vue&type=script&lang=js&"
export * from "./AddTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ba7ee8",
  null
  
)

export default component.exports